import { SENSITIVE_STRING } from "@smithy/smithy-client";
import { PollyServiceException as __BaseException } from "./PollyServiceException";
export class LexiconNotFoundException extends __BaseException {
    name = "LexiconNotFoundException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "LexiconNotFoundException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, LexiconNotFoundException.prototype);
    }
}
export class ServiceFailureException extends __BaseException {
    name = "ServiceFailureException";
    $fault = "server";
    constructor(opts) {
        super({
            name: "ServiceFailureException",
            $fault: "server",
            ...opts,
        });
        Object.setPrototypeOf(this, ServiceFailureException.prototype);
    }
}
export const Engine = {
    GENERATIVE: "generative",
    LONG_FORM: "long-form",
    NEURAL: "neural",
    STANDARD: "standard",
};
export const LanguageCode = {
    ar_AE: "ar-AE",
    arb: "arb",
    ca_ES: "ca-ES",
    cmn_CN: "cmn-CN",
    cs_CZ: "cs-CZ",
    cy_GB: "cy-GB",
    da_DK: "da-DK",
    de_AT: "de-AT",
    de_CH: "de-CH",
    de_DE: "de-DE",
    en_AU: "en-AU",
    en_GB: "en-GB",
    en_GB_WLS: "en-GB-WLS",
    en_IE: "en-IE",
    en_IN: "en-IN",
    en_NZ: "en-NZ",
    en_SG: "en-SG",
    en_US: "en-US",
    en_ZA: "en-ZA",
    es_ES: "es-ES",
    es_MX: "es-MX",
    es_US: "es-US",
    fi_FI: "fi-FI",
    fr_BE: "fr-BE",
    fr_CA: "fr-CA",
    fr_FR: "fr-FR",
    hi_IN: "hi-IN",
    is_IS: "is-IS",
    it_IT: "it-IT",
    ja_JP: "ja-JP",
    ko_KR: "ko-KR",
    nb_NO: "nb-NO",
    nl_BE: "nl-BE",
    nl_NL: "nl-NL",
    pl_PL: "pl-PL",
    pt_BR: "pt-BR",
    pt_PT: "pt-PT",
    ro_RO: "ro-RO",
    ru_RU: "ru-RU",
    sv_SE: "sv-SE",
    tr_TR: "tr-TR",
    yue_CN: "yue-CN",
};
export const Gender = {
    Female: "Female",
    Male: "Male",
};
export const VoiceId = {
    Aditi: "Aditi",
    Adriano: "Adriano",
    Amy: "Amy",
    Andres: "Andres",
    Aria: "Aria",
    Arlet: "Arlet",
    Arthur: "Arthur",
    Astrid: "Astrid",
    Ayanda: "Ayanda",
    Bianca: "Bianca",
    Brian: "Brian",
    Burcu: "Burcu",
    Camila: "Camila",
    Carla: "Carla",
    Carmen: "Carmen",
    Celine: "Celine",
    Chantal: "Chantal",
    Conchita: "Conchita",
    Cristiano: "Cristiano",
    Daniel: "Daniel",
    Danielle: "Danielle",
    Dora: "Dora",
    Elin: "Elin",
    Emma: "Emma",
    Enrique: "Enrique",
    Ewa: "Ewa",
    Filiz: "Filiz",
    Gabrielle: "Gabrielle",
    Geraint: "Geraint",
    Giorgio: "Giorgio",
    Gregory: "Gregory",
    Gwyneth: "Gwyneth",
    Hala: "Hala",
    Hannah: "Hannah",
    Hans: "Hans",
    Hiujin: "Hiujin",
    Ida: "Ida",
    Ines: "Ines",
    Isabelle: "Isabelle",
    Ivy: "Ivy",
    Jacek: "Jacek",
    Jan: "Jan",
    Jasmine: "Jasmine",
    Jitka: "Jitka",
    Joanna: "Joanna",
    Joey: "Joey",
    Justin: "Justin",
    Kajal: "Kajal",
    Karl: "Karl",
    Kazuha: "Kazuha",
    Kendra: "Kendra",
    Kevin: "Kevin",
    Kimberly: "Kimberly",
    Laura: "Laura",
    Lea: "Lea",
    Liam: "Liam",
    Lisa: "Lisa",
    Liv: "Liv",
    Lotte: "Lotte",
    Lucia: "Lucia",
    Lupe: "Lupe",
    Mads: "Mads",
    Maja: "Maja",
    Marlene: "Marlene",
    Mathieu: "Mathieu",
    Matthew: "Matthew",
    Maxim: "Maxim",
    Mia: "Mia",
    Miguel: "Miguel",
    Mizuki: "Mizuki",
    Naja: "Naja",
    Niamh: "Niamh",
    Nicole: "Nicole",
    Ola: "Ola",
    Olivia: "Olivia",
    Pedro: "Pedro",
    Penelope: "Penelope",
    Raveena: "Raveena",
    Remi: "Remi",
    Ricardo: "Ricardo",
    Ruben: "Ruben",
    Russell: "Russell",
    Ruth: "Ruth",
    Sabrina: "Sabrina",
    Salli: "Salli",
    Seoyeon: "Seoyeon",
    Sergio: "Sergio",
    Sofie: "Sofie",
    Stephen: "Stephen",
    Suvi: "Suvi",
    Takumi: "Takumi",
    Tatyana: "Tatyana",
    Thiago: "Thiago",
    Tomoko: "Tomoko",
    Vicki: "Vicki",
    Vitoria: "Vitoria",
    Zayd: "Zayd",
    Zeina: "Zeina",
    Zhiyu: "Zhiyu",
};
export class InvalidNextTokenException extends __BaseException {
    name = "InvalidNextTokenException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "InvalidNextTokenException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidNextTokenException.prototype);
    }
}
export class EngineNotSupportedException extends __BaseException {
    name = "EngineNotSupportedException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "EngineNotSupportedException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, EngineNotSupportedException.prototype);
    }
}
export const OutputFormat = {
    JSON: "json",
    MP3: "mp3",
    OGG_VORBIS: "ogg_vorbis",
    PCM: "pcm",
};
export const SpeechMarkType = {
    SENTENCE: "sentence",
    SSML: "ssml",
    VISEME: "viseme",
    WORD: "word",
};
export const TaskStatus = {
    COMPLETED: "completed",
    FAILED: "failed",
    IN_PROGRESS: "inProgress",
    SCHEDULED: "scheduled",
};
export const TextType = {
    SSML: "ssml",
    TEXT: "text",
};
export class InvalidTaskIdException extends __BaseException {
    name = "InvalidTaskIdException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "InvalidTaskIdException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidTaskIdException.prototype);
    }
}
export class SynthesisTaskNotFoundException extends __BaseException {
    name = "SynthesisTaskNotFoundException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "SynthesisTaskNotFoundException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, SynthesisTaskNotFoundException.prototype);
    }
}
export class InvalidLexiconException extends __BaseException {
    name = "InvalidLexiconException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "InvalidLexiconException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidLexiconException.prototype);
    }
}
export class InvalidS3BucketException extends __BaseException {
    name = "InvalidS3BucketException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "InvalidS3BucketException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidS3BucketException.prototype);
    }
}
export class InvalidS3KeyException extends __BaseException {
    name = "InvalidS3KeyException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "InvalidS3KeyException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidS3KeyException.prototype);
    }
}
export class InvalidSampleRateException extends __BaseException {
    name = "InvalidSampleRateException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "InvalidSampleRateException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidSampleRateException.prototype);
    }
}
export class InvalidSnsTopicArnException extends __BaseException {
    name = "InvalidSnsTopicArnException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "InvalidSnsTopicArnException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidSnsTopicArnException.prototype);
    }
}
export class InvalidSsmlException extends __BaseException {
    name = "InvalidSsmlException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "InvalidSsmlException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidSsmlException.prototype);
    }
}
export class LanguageNotSupportedException extends __BaseException {
    name = "LanguageNotSupportedException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "LanguageNotSupportedException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, LanguageNotSupportedException.prototype);
    }
}
export class LexiconSizeExceededException extends __BaseException {
    name = "LexiconSizeExceededException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "LexiconSizeExceededException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, LexiconSizeExceededException.prototype);
    }
}
export class MarksNotSupportedForFormatException extends __BaseException {
    name = "MarksNotSupportedForFormatException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "MarksNotSupportedForFormatException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, MarksNotSupportedForFormatException.prototype);
    }
}
export class MaxLexemeLengthExceededException extends __BaseException {
    name = "MaxLexemeLengthExceededException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "MaxLexemeLengthExceededException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, MaxLexemeLengthExceededException.prototype);
    }
}
export class MaxLexiconsNumberExceededException extends __BaseException {
    name = "MaxLexiconsNumberExceededException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "MaxLexiconsNumberExceededException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, MaxLexiconsNumberExceededException.prototype);
    }
}
export class UnsupportedPlsAlphabetException extends __BaseException {
    name = "UnsupportedPlsAlphabetException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "UnsupportedPlsAlphabetException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, UnsupportedPlsAlphabetException.prototype);
    }
}
export class UnsupportedPlsLanguageException extends __BaseException {
    name = "UnsupportedPlsLanguageException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "UnsupportedPlsLanguageException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, UnsupportedPlsLanguageException.prototype);
    }
}
export class SsmlMarksNotSupportedForTextTypeException extends __BaseException {
    name = "SsmlMarksNotSupportedForTextTypeException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "SsmlMarksNotSupportedForTextTypeException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, SsmlMarksNotSupportedForTextTypeException.prototype);
    }
}
export class TextLengthExceededException extends __BaseException {
    name = "TextLengthExceededException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "TextLengthExceededException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, TextLengthExceededException.prototype);
    }
}
export const LexiconFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Content && { Content: SENSITIVE_STRING }),
});
export const GetLexiconOutputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Lexicon && { Lexicon: LexiconFilterSensitiveLog(obj.Lexicon) }),
});
export const PutLexiconInputFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Content && { Content: SENSITIVE_STRING }),
});
export const SynthesizeSpeechOutputFilterSensitiveLog = (obj) => ({
    ...obj,
});
